import { createContentPropTypes } from '../../helpers/content';

export const finalApprovalModalContent = {
	finalApprovalModalTitle: 'Cannot authorise',
	finalApprovalBody:
		'Your payment cannot be authorised yet. Someone has already authorised this payment. The payment will need to be authorised again with the live exchange rate.',
	finalApprovalModalContinueButton: 'Continue',
};

export const contentPropTypes = createContentPropTypes(finalApprovalModalContent);
